import {
  LOADING_SITEMAP_DATA,
  LOAD_SITEMAP_DATA_ERROR,
  LOAD_SITEMAP_DATA_SUCCESS, CLEAR_SITEMAP_DATA, UPDATE_FOCUSED_POINT_SITEMAP,
} from 'constants/ActionTypes';

const initState = {
  reportDetails: {},
  reportAddresses: [],
  focusedPointIndex: 0,
  loading: false,
  error: false,
};

export default (state = initState, action = {}) => {
  switch (action.type) {
    case LOADING_SITEMAP_DATA: return { ...state, loading: true, error: false };
    case LOAD_SITEMAP_DATA_SUCCESS: return {
      ...state,
      reportDetails: action.reportDetails,
      reportAddresses: action.reportAddresses,
      focusedPointIndex: action.focusedPointIndex,
      loading: false,
      error: false,
    };
    case UPDATE_FOCUSED_POINT_SITEMAP: return { ...state, focusedPointIndex: action.focusedPointIndex };
    case CLEAR_SITEMAP_DATA: return initState;
    case LOAD_SITEMAP_DATA_ERROR: return { ...state, error: true, loading: false };
    default: return state;
  }
};
